export default __webpack_public_path__ + "static/media/wi-na.4ac6bc86.svg";